import React from 'react';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-logo.svg`;
const LOGO_NAV_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-logo-nav.png`;
const LOGO_FOOTER_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-logo-footer.png`;
const LOGO_LIGHT_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-logo-light.svg`;
export const HERO_MARK_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-mark.svg`;
const MARK_SRC = HERO_MARK_SRC;
const ICON_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-mark.svg`;

/**
 * @param {'full' | 'mark' | 'icon'} variant
 * @param {'hero' | 'nav' | 'footer' | 'inline'} placement
 * @param {'default' | 'light'} tone
 */
export default function BrandLogo({
  variant = 'full',
  placement = 'inline',
  tone = 'default',
  className = '',
  alt,
}) {
  const src =
    placement === 'nav'
      ? LOGO_NAV_SRC
      : placement === 'footer'
        ? LOGO_FOOTER_SRC
        : variant === 'full'
        ? tone === 'light'
          ? LOGO_LIGHT_SRC
          : LOGO_SRC
        : variant === 'mark'
          ? MARK_SRC
          : ICON_SRC;

  const defaultAlt =
    alt ||
    (variant === 'full'
      ? 'Auralux — Harmony Through Precision and Sustainability'
      : 'Auralux');

  const placementClass =
    placement === 'hero' && variant === 'mark'
      ? 'brand-logo brand-logo--hero-mark'
      : placement === 'hero'
        ? 'brand-logo brand-logo--hero'
        : placement === 'nav'
          ? 'brand-logo brand-logo--nav'
          : placement === 'footer'
            ? 'brand-logo brand-logo--footer'
            : 'brand-logo';

  return (
    <img
      src={src}
      alt={defaultAlt}
      className={[placementClass, className].filter(Boolean).join(' ')}
      width={variant === 'mark' ? 1831 : variant === 'icon' ? 64 : undefined}
      height={variant === 'mark' ? 2048 : variant === 'icon' ? 64 : undefined}
      decoding="async"
      fetchPriority={placement === 'hero' && variant === 'mark' ? 'high' : undefined}
    />
  );
}
